<ngx-ui-loader *ngIf="showLoader" [fgsType]="spinnerType" logoUrl="./assets/images/Cafeterialoader.png">
</ngx-ui-loader>
<router-outlet></router-outlet>